export default __webpack_public_path__ + "static/media/72t.8a729600.jpg";